module.exports = __webpack_public_path__ + "img/revistas.ca10f2de.png";